"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _merge2 = _interopRequireDefault(require("lodash/merge"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _rcTrigger = _interopRequireDefault(require("rc-trigger"));

var _PopupProvider_placements = require("./PopupProvider_placements");

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * A utility component that provides enhancements for custom popups e.g. Tooltip,
 * Popover, Dropdown, Notification. To view additional props see rc-trigger:
 * https://github.com/react-component/trigger
 */
// TODO: Replace rc-trigger with own solution to support additional
//  functional and control:
// 1) Set custom anchor point for popup e.g. Hover a Button, and
//   popup will display over an Input element.
// 2) Use data-attr for styling variations
// 3) Allow custom manual trigger to display popup
// 4) More natural solution to deal with scrolling and popup position than
//   relying on popupContainer
var PopupProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PopupProvider, _React$Component);

  function PopupProvider() {
    _classCallCheck(this, PopupProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(PopupProvider).apply(this, arguments));
  }

  _createClass(PopupProvider, [{
    key: "getPrebuiltPlacementMap",

    /**
     * @param {string} prebuiltPlacementMap - real built in placement :)
     * @returns {object} placement map for popover
     */
    value: function getPrebuiltPlacementMap(prebuiltPlacementMap) {
      var placementMap;

      switch (prebuiltPlacementMap) {
        case 'offset10px':
          placementMap = this.getPlacementsWithOffset(_PopupProvider_placements.placementPositions, 10);
          break;

        default:
          placementMap = this.getPlacementsWithOffset(_PopupProvider_placements.placementPositions, 0);
      }

      return placementMap;
    }
    /**
     * @param {object} placementMap - Placement positions
     * @param {number} offset - offset for popup
     * @returns {object} placement map for popup
     */

  }, {
    key: "getPlacementsWithOffset",
    value: function getPlacementsWithOffset(placementMap, offset) {
      var offsets = {
        leftTop: {
          offset: [-offset, 0]
        },
        left: {
          offset: [-offset, 0]
        },
        leftBottom: {
          offset: [-offset, 0]
        },
        topLeft: {
          offset: [0, -offset]
        },
        top: {
          offset: [0, -offset]
        },
        topRight: {
          offset: [0, -offset]
        },
        rightTop: {
          offset: [offset, 0]
        },
        right: {
          offset: [offset, 0]
        },
        rightBottom: {
          offset: [offset, 0]
        },
        bottomLeft: {
          offset: [0, offset]
        },
        bottom: {
          offset: [0, offset]
        },
        bottomRight: {
          offset: [0, offset]
        }
      };
      return (0, _merge2.default)(offsets, placementMap);
    }
    /**
     * @param {string} transitionType - transition type
     * @returns {string} transition name
     */

  }, {
    key: "getTransition",
    value: function getTransition(transitionType) {
      var normal = 0.2;
      var fast = 0.15;
      var veryFast = 0.1;
      var transitionProps = {};

      switch (transitionType) {
        case 'slide':
          transitionProps.transitionName = this.getTransitionSlideDirection();
          transitionProps.transitionEnterDelay = fast;
          transitionProps.transitionLeaveDelay = veryFast;
          break;

        case 'zoom-big-fast':
          transitionProps.transitionName = 'zoom-big-fast';
          transitionProps.transitionEnterDelay = veryFast;
          transitionProps.transitionLeaveDelay = veryFast;
          break;

        case 'zoom-big':
          transitionProps.transitionName = 'zoom-big';
          transitionProps.transitionEnterDelay = normal;
          transitionProps.transitionLeaveDelay = normal;
          break;

        default: // es-lint wants this

      }

      return transitionProps;
    }
    /**
     * @returns {string} transition name
     */

  }, {
    key: "getTransitionSlideDirection",
    value: function getTransitionSlideDirection() {
      var popupPlacement = this.props.popupPlacement;
      var transitionName;

      switch (popupPlacement) {
        case 'leftTop':
        case 'left':
        case 'leftBottom':
          transitionName = 'slide-right';
          break;

        case 'topLeft':
        case 'top':
        case 'topRight':
          transitionName = 'slide-down';
          break;

        case 'rightTop':
        case 'right':
        case 'rightBottom':
          transitionName = 'slide-left';
          break;

        case 'bottomLeft':
        case 'bottom':
        case 'bottomRight':
          transitionName = 'slide-up';
          break;

        default:
          transitionName = 'slide-up';
      }

      return transitionName;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          builtinPlacements = _this$props.builtinPlacements,
          children = _this$props.children,
          mouseEnterDelay = _this$props.mouseEnterDelay,
          mouseLeaveDelay = _this$props.mouseLeaveDelay,
          popupClassName = _this$props.popupClassName,
          popupPlacement = _this$props.popupPlacement,
          popupTransitionName = _this$props.popupTransitionName,
          prebuiltPlacementMap = _this$props.prebuiltPlacementMap,
          transitionType = _this$props.transitionType,
          popupStyle = _this$props.popupStyle,
          props = _objectWithoutProperties(_this$props, ["builtinPlacements", "children", "mouseEnterDelay", "mouseLeaveDelay", "popupClassName", "popupPlacement", "popupTransitionName", "prebuiltPlacementMap", "transitionType", "popupStyle"]);

      var _this$getTransition = this.getTransition(transitionType),
          transitionName = _this$getTransition.transitionName,
          transitionEnterDelay = _this$getTransition.transitionEnterDelay,
          transitionLeaveDelay = _this$getTransition.transitionLeaveDelay;

      return _react.default.createElement(_rcTrigger.default, _extends({
        builtinPlacements: builtinPlacements || this.getPrebuiltPlacementMap(prebuiltPlacementMap),
        mouseEnterDelay: mouseEnterDelay || transitionEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay || transitionLeaveDelay,
        popupClassName: (0, _classnames.default)(popupClassName, "".concat(_ThemeManager.default.getVar('classPrefix'), "-popup ").concat(_ThemeManager.default.getVar('classPrefix'))),
        popupPlacement: popupPlacement,
        popupStyle: _objectSpread({
          position: 'absolute'
        }, popupStyle),
        popupTransitionName: popupTransitionName || transitionName,
        prefixCls: ""
      }, props), children);
    }
  }]);

  return PopupProvider;
}(_react.default.Component);

exports.default = PopupProvider;
PopupProvider.defaultProps = {
  prebuiltPlacementMap: 'offset0px'
};
PopupProvider.propTypes = {
  /**
   * Event to trigger PopupProvider.
   */
  action: _propTypes.default.oneOf(['hover', 'click', 'focus', 'contextMenu']),

  /**
   * This is the component/text the PopupProvider will pop over.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,

  /**
   * Called when popup visibility changes.
   */
  onPopupVisibleChange: _propTypes.default.func,

  /**
   * The popup that will show above the children.
   */
  popup: _propTypes.default.element.isRequired,

  /**
   * Customize additional class name for popup.
   */
  popupClassName: _propTypes.default.string,

  /**
   * Set placement position of dropdown over children.
   */
  popupPlacement: _propTypes.default.oneOf(['leftTop', 'left', 'leftBottom', 'topLeft', 'top', 'topRight', 'rightTop', 'right', 'rightBottom', 'bottomLeft', 'bottom', 'bottomRight']),

  /**
   * Set visibility of popup. Note: This will override and ignore state of the 'action' prop.
   */
  popupVisible: _propTypes.default.bool,

  /**
   * Premade placements maps featuring 9 directions with different offsets.
   */
  prebuiltPlacementMap: _propTypes.default.oneOf(['offset0px', 'offset10px']),

  /**
   * Reveal and hide transition for popup.
   */
  transitionType: _propTypes.default.oneOf(['none', 'slide', 'zoom-big', 'zoom-big-fast']),

  /**
   * Container to place popup in. Use when popup will scroll with content from a source other
   * than the body. e.g. `() => document.querySelector('.modal')`
   */
  getPopupContainer: _propTypes.default.func
};